export const RESET_NOTEBOOK = 'RESET_NOTEBOOK';
